//  ##   ##  ##     ##  #####    #####    ###    ####
//  ##   ##  ####   ##  ##  ##   ##      ## ##   ##  ##
//  ##   ##  ##  ## ##  #####    #####  ##   ##  ##  ##
//  ##   ##  ##    ###  ##  ##   ##     #######  ##  ##
//   #####   ##     ##  ##   ##  #####  ##   ##  ####

// 未読位置に初期スクロールする
function scrollUnread() {
  const newsBody = document.getElementById('newsList')
  const unreadLine = document.getElementById('newsUnreadLine')
  if (!newsBody || !unreadLine) {
    return
  }
  newsBody.scrollTop = unreadLine.offsetTop - 60
}
scrollUnread()
